var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "demo-dialog",
      attrs: { visible: _vm.showPreview, "before-close": _vm.swiperClose },
      on: {
        "update:visible": function($event) {
          _vm.showPreview = $event
        }
      }
    },
    [
      _c(
        "el-carousel",
        { staticClass: "picsCard", attrs: { autoplay: false } },
        _vm._l(_vm.picsList, function(item, index) {
          return _c(
            "el-carousel-item",
            { key: item + index },
            [_c("el-image", { attrs: { src: item } })],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11a24eac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11a24eac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PurchasingManagement/PictureSwiper.vue
// module id = null
// module chunks = 